import $axios from "@/utils/axios.js";
import $router from "@/router/index.js";

const controller = new AbortController();

const state = {
  token: localStorage.getItem("token"),
  data: JSON.parse(localStorage.getItem("data")),
};

const getters = {
  //fungsi is auth ini akan bernilai true atau false
  isAuth: (state) => {
    return (
      state.token != "null" && state.token != null && state.token != "undefined"
    );
  },
};

const mutations = {
  retrieveToken(state, { token, permission, data }) {
    state.token = token;

    state.data = data;
  },

  removeToken(state) {
    state.token = null;
    state.data = null;
  },
};

const actions = {
  Register(context, payload) {
    this.state.isLoading = true;
    return new Promise((resolve, reject) => {
      $axios
        .post("/register", {
          ...payload,
        })
        .then((response) => {
          this.state.isLoading = false;
          resolve(response.data);
        })
        .catch((error) => {
          this.state.isLoading = false;
          console.log(error);
          reject(error);
        });
    });
  },
  retrieveToken(context, credentials) {
    this.state.isLoading = true;
    return new Promise((resolve, reject) => {
      $axios
        .post("/login", {
          nama: credentials.nama,
          email: credentials.email,
        })
        .then((response) => {
          //alert(response.data.data.access_token)
          const token = response.data.token;
          const data = response.data;
          const permission = response.data.permission;
          localStorage.setItem("locked", false);
          localStorage.setItem("token", token);
          localStorage.setItem("data", JSON.stringify(data));
          localStorage.setItem("permission", JSON.stringify(permission));
          context.commit("retrieveToken", { token, permission, data });
          //alert('tes')
          //alert(this.$socket())
          $router.push("/");
          this.state.isLoading = false;
          resolve(response.data);
        })
        .catch((error) => {
          this.state.isLoading = false;
          console.log(error);
          reject(error);
        });
    });
  },

  Logout(context) {
    return new Promise((resolve, reject) => {
      localStorage.clear();
      $router.push({ name: "login" });
      controller.abort();

      context.commit("removeToken");
    });
  },
};

export default {
  namespace: true,
  state,
  getters,
  mutations,
  actions,
};
